import { render, staticRenderFns } from "./SSelectFarm.vue?vue&type=template&id=199ae375"
import script from "./SSelectFarm.vue?vue&type=script&lang=js"
export * from "./SSelectFarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports